import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { JobPublishOrUnpublish, UrgentHiringTag } from "./UrgentHiringTagAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const UrgentHiringTagAsync = createAsyncThunk(
    "UrgentHiringTag/add",
    async ({ uuid, urgent_hiring_tag }) => {
        try {
            const data = await UrgentHiringTag(uuid, urgent_hiring_tag);
            // console.log("data in slice", data);
            return data;
        } catch (error) {
            // console.log("error :", error);
            return error;

            // return rejectWithValue(error.message);
        }
    }
);

const UrgentHiringTagSlice = createSlice({
    name: "UrgentHiringTag",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(UrgentHiringTagAsync.fulfilled, (state, action) => {
                state.loading = false;
                if (Array.isArray(state.data)) {
                    state.data?.push(action.payload);
                } else {
                    state.data = [action.payload]; // Initialize as an array if it's not already
                }
            })
            .addCase(UrgentHiringTagAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message || "Failed to add CompanyReview";
            });
    },
});

export const selectJob = (state) => state.UrgentHiringTag.data;

export default UrgentHiringTagSlice.reducer;
